/**
 * DDU money: montos redondos + moneda en palabras (sin símbolos).
 * Primera letra mayúscula. USD/CAD/etc. con nombre completo.
 * $ ambiguo → moneda activa de la tienda (no forzar USD).
 */
(function () {
  if (window.__dduMoneyInit) return;
  window.__dduMoneyInit = true; // ddu-money-v3 thousands+skip-dtr 1786486617.447464

  // Primera letra mayúscula siempre
  var NAMES_ES = {
    USD: 'Dólares estadounidenses',
    CAD: 'Dólares canadienses',
    AUD: 'Dólares australianos',
    NZD: 'Dólares neozelandeses',
    EUR: 'Euros',
    GBP: 'Libras',
    MXN: 'Pesos mexicanos',
    ARS: 'Pesos argentinos',
    CLP: 'Pesos chilenos',
    COP: 'Pesos colombianos',
    UYU: 'Pesos uruguayos',
    PEN: 'Soles',
    BRL: 'Reales',
    CHF: 'Francos suizos',
    JPY: 'Yenes',
    CRC: 'Colones',
    GTQ: 'Quetzales',
    DOP: 'Pesos dominicanos',
    BOB: 'Bolivianos',
    PYG: 'Guaraníes',
    SEK: 'Coronas suecas',
    NOK: 'Coronas noruegas',
    DKK: 'Coronas danesas',
    PLN: 'Zlotys',
    CZK: 'Coronas checas',
    ILS: 'Shéquels',
    AED: 'Dirhams',
    SAR: 'Riales',
    INR: 'Rupias',
    CNY: 'Yuanes',
    KRW: 'Wones',
    HNL: 'Lempiras',
    NIO: 'Córdobas',
    PAB: 'Balboas',
    VES: 'Bolívares'
  };
  var NAMES_EN = {
    USD: 'US dollars',
    CAD: 'Canadian dollars',
    AUD: 'Australian dollars',
    NZD: 'New Zealand dollars',
    EUR: 'Euros',
    GBP: 'Pounds',
    MXN: 'Mexican pesos',
    ARS: 'Argentine pesos',
    CLP: 'Chilean pesos',
    COP: 'Colombian pesos',
    UYU: 'Uruguayan pesos',
    PEN: 'Soles',
    BRL: 'Reais',
    CHF: 'Swiss francs',
    JPY: 'Yen',
    INR: 'Rupees',
    CNY: 'Yuan',
    KRW: 'Won'
  };

  var ZERO_DECIMAL = { JPY: 1, KRW: 1, VND: 1, CLP: 1, UGX: 1, XAF: 1, XOF: 1 };

  function isEs() {
    try {
      var l = (document.documentElement.lang || (window.Shopify && Shopify.locale) || 'es').toLowerCase();
      return l.indexOf('en') !== 0;
    } catch (e) {
      return true;
    }
  }

  function isUyStore() {
    try {
      var h = (location.hostname || '').toLowerCase();
      if (h.indexOf('com.uy') >= 0 || h.indexOf('famuiu') >= 0) return true;
      if (window.__dduIsUyStore === true) return true;
    } catch (e) {}
    return false;
  }

  function visitorCountry() {
    try {
      if (window.__dduCountry) return String(window.__dduCountry).toUpperCase();
    } catch (e) {}
    try {
      if (window.Shopify && Shopify.country) return String(Shopify.country).toUpperCase();
    } catch (e) {}
    try {
      var m = document.querySelector('meta[name="ddu-country"]');
      if (m && m.content) return String(m.content).toUpperCase();
    } catch (e) {}
    return '';
  }

  function shopCurrency() {
    try {
      if (window.__dduShopCurrency) return String(window.__dduShopCurrency).toUpperCase();
    } catch (e) {}
    try {
      if (window.Shopify && Shopify.currency && Shopify.currency.active) {
        return String(Shopify.currency.active).toUpperCase();
      }
    } catch (e) {}
    // Tienda UY siempre UYU si no hay dato
    if (isUyStore()) return 'UYU';
    return 'USD';
  }

  function activeCurrency() {
    // Visitante en Uruguay en tienda UY → pesos
    if (isUyStore()) return 'UYU';
    return shopCurrency();
  }

  function currencyName(code) {
    code = String(code || activeCurrency()).toUpperCase();
    var map = isEs() ? NAMES_ES : NAMES_EN;
    return map[code] || code;
  }

  function parseAmount(text) {
    if (!text) return null;
    var t = String(text).replace(/\s/g, ' ').trim();
    var m = t.match(/-?[\d.,]+/);
    if (!m) return null;
    var raw = m[0];
    var hasComma = raw.indexOf(',') >= 0;
    var hasDot = raw.indexOf('.') >= 0;
    if (hasComma && hasDot) {
      // Both: the last separator is decimal
      if (raw.lastIndexOf(',') > raw.lastIndexOf('.')) {
        raw = raw.replace(/\./g, '').replace(',', '.');
      } else {
        raw = raw.replace(/,/g, '');
      }
    } else if (hasComma && !hasDot) {
      // 1.234.567,89 already handled; 8047,5 or 8.047 style with comma
      if (/,\d{1,2}$/.test(raw)) raw = raw.replace(',', '.');
      else raw = raw.replace(/,/g, '');
    } else if (hasDot && !hasComma) {
      var dots = (raw.match(/\./g) || []).length;
      if (dots > 1) {
        raw = raw.replace(/\./g, ''); // 1.234.567
      } else {
        var parts = raw.split('.');
        // Exactly 3 digits after dot → thousands separator in es-UY (8.047 = 8047), NOT cents
        // (UYU/CLP/COP/JPY have 0 decimal places in our catalog)
        if (parts[1] && parts[1].length === 3) {
          raw = parts[0] + parts[1];
        }
        // else keep as decimal (19.99)
      }
    }
    var n = parseFloat(raw);
    return isNaN(n) ? null : n;
  }

  function detectCurrency(text) {
    var t = String(text || '');
    // Códigos ISO explícitos
    var codes = t.match(/\b([A-Z]{3})\b/g) || [];
    for (var i = 0; i < codes.length; i++) {
      if (NAMES_ES[codes[i]] || NAMES_EN[codes[i]]) return codes[i];
    }
    // Nombres ya formateados
    if (/pesos\s+uruguayos|uruguayan\s+pesos/i.test(t)) return 'UYU';
    if (/d[oó]lares\s+estadounidenses|us\s+dollars/i.test(t)) return 'USD';
    if (/d[oó]lares\s+canadienses|canadian\s+dollars/i.test(t)) return 'CAD';
    if (/d[oó]lares\s+australianos|australian\s+dollars/i.test(t)) return 'AUD';
    if (/pesos\s+mexicanos|mexican\s+pesos/i.test(t)) return 'MXN';
    if (/pesos\s+argentinos|argentine\s+pesos/i.test(t)) return 'ARS';
    if (/euros/i.test(t)) return 'EUR';
    if (/libras|pounds/i.test(t)) return 'GBP';
    if (/reales|reais/i.test(t)) return 'BRL';

    // Símbolos con prefijo claro
    if (/US\$|USD/i.test(t)) return 'USD';
    if (/CA\$|CAD/i.test(t)) return 'CAD';
    if (/A\$|AUD/i.test(t) && !/CA\$/i.test(t)) return 'AUD';
    if (/MX\$|MXN/i.test(t)) return 'MXN';
    if (/AR\$|ARS/i.test(t)) return 'ARS';
    if (/\$U|UYU/i.test(t)) return 'UYU';
    if (t.indexOf('€') >= 0) return 'EUR';
    if (t.indexOf('£') >= 0) return 'GBP';
    if (t.indexOf('R$') >= 0) return 'BRL';

    // $ solo → moneda de la tienda (UYU en .com.uy, no USD)
    if (t.indexOf('$') >= 0) return activeCurrency();

    return activeCurrency();
  }

  function formatMoneyParts(amount, code) {
    var n = Math.round(Number(amount) || 0);
    var name = currencyName(code);
    var num;
    try {
      num = n.toLocaleString(isEs() ? 'es-UY' : 'en-US', {
        maximumFractionDigits: 0,
        minimumFractionDigits: 0
      });
    } catch (e) {
      num = String(n);
    }
    return num + ' ' + name;
  }
  window.dduFormatMoney = formatMoneyParts;
  window.dduCurrencyName = currencyName;

  function patchShopify() {
    try {
      if (!window.Shopify) return;
      var orig = Shopify.formatMoney;
      Shopify.formatMoney = function (cents, format) {
        var cur = activeCurrency();
        var major = ZERO_DECIMAL[cur] ? Number(cents) : Number(cents) / 100;
        if (isNaN(major) && typeof orig === 'function') {
          return reformatText(orig.call(Shopify, cents, format));
        }
        return formatMoneyParts(major, cur);
      };
    } catch (e) {}
  }

  function shouldSkip(el) {
    if (!el || el.nodeType !== 1) return true;
    if (el.closest('script,style,noscript,code,pre,textarea,input,option')) return true;
    if (el.getAttribute('data-ddu-money') === 'keep') return true;
    // Never rewrite Test del Guardián prices (already formatted correctly)
    if (el.closest('#dtr, .dtr-tier, .dtr-price, [data-cart-handles]')) return true;
    if (el.classList && (el.classList.contains('dtr-price') || el.classList.contains('dtr-btn'))) return true;
    return false;
  }

  // Textos ya en palabras (incluye nombres largos)
  var WORD_MONEY_RE =
    /\d[\d.,\s]*\s+(D[oó]lares\s+\w+|Pesos\s+\w+|Euros|Libras|Reales|Soles|Yenes|Francos|Coronas|US dollars|Canadian dollars|Uruguayan pesos|Mexican pesos|dollars|pounds|euros|reais|yen)\b/i;

  function reformatText(text) {
    if (!text) return text;
    var t = String(text).trim();
    if (!t) return text;

    // Leave explicit "$ 8.047 UYU" style alone if amount parses to >= 100
    if (/\$\s*[\d.]+\s*UYU/i.test(t)) {
      var a0 = parseAmount(t);
      if (a0 != null && a0 >= 100) return formatMoneyParts(a0, 'UYU');
    }

    // Ya formateado con nombre largo: normalizar capitalización / redondeo
    if (WORD_MONEY_RE.test(t) || /\d[\d.,\s]*\s+(d[oó]lares|euros|pesos|libras|reales|soles|dollars|pounds)\b/i.test(t)) {
      var amt = parseAmount(t);
      var code = detectCurrency(t);
      if (amt != null && code) return formatMoneyParts(amt, code);
      return t;
    }

    if (!/[\d$€£¥₩]/.test(t) && !/\b[A-Z]{3}\b/.test(t)) return text;

    var amount = parseAmount(t);
    if (amount == null) return text;
    var cur = detectCurrency(t);
    if (!/[$€£¥₩]|USD|EUR|GBP|MXN|ARS|CLP|COP|UYU|BRL|PEN|CAD|AUD|dólar|dolar|peso|euro/i.test(t) && amount < 1) {
      return text;
    }
    return formatMoneyParts(amount, cur);
  }

  var PRICE_SEL = [
    '.price',
    '.price-item',
    '.money',
    '[data-product-price]',
    '.product-price',
    '.cart-items__price',
    '.cart-items__price-unit',
    '.cart-totals__total-value',
    '.cart-totals__original-value',
    '.cart-discounts__value',
    '.price__regular',
    '.price__sale',
    '.price-item--regular',
    '.price-item--sale',
    '.unit-price',
    '.product-card .price',
    '.card-price',
    '.collection-product-card .price',
    '.ddu-fs-amt',
    '[class*="price"]'
  ].join(',');

  function processElement(el) {
    if (shouldSkip(el)) return;
    if (el.dataset && el.dataset.dduMoneyDone === el.textContent) return;
    var text = el.childElementCount === 0 ? el.textContent : null;
    if (text == null) {
      if (el.children.length <= 2 && (el.textContent || '').length < 64) text = el.textContent;
      else return;
    }
    text = String(text).trim();
    if (!text || text.length > 64) return;
    if (!/\d/.test(text)) return;
    if (!/[$€£¥₩.,\dA-Za-zÁÉÍÓÚáéíóúñ]/.test(text)) return;
    var next = reformatText(text);
    if (next && next !== text) {
      el.textContent = next;
      if (el.dataset) el.dataset.dduMoneyDone = next;
    }
  }

  function scan(root) {
    root = root || document;
    try {
      root.querySelectorAll(PRICE_SEL).forEach(processElement);
    } catch (e) {}
    // También etiqueta de moneda del carrito
    try {
      document.querySelectorAll('[data-ddu-fs-currency], .ddu-fs-bar__currency').forEach(function (el) {
        var cur = activeCurrency();
        var name = currencyName(cur);
        var es = isEs();
        var label = es ? 'Moneda: ' + name : 'Currency: ' + name;
        if (el.textContent !== label) el.textContent = label;
      });
    } catch (e) {}
  }

  function boot() {
    patchShopify();
    scan(document);
    try {
      var mo = new MutationObserver(function (muts) {
        muts.forEach(function (m) {
          if (m.type === 'childList') {
            m.addedNodes.forEach(function (n) {
              if (n.nodeType === 1) {
                processElement(n);
                try {
                  n.querySelectorAll && n.querySelectorAll(PRICE_SEL).forEach(processElement);
                } catch (e) {}
              }
            });
          } else if (m.type === 'characterData' && m.target && m.target.parentElement) {
            processElement(m.target.parentElement);
          }
        });
      });
      mo.observe(document.documentElement, { childList: true, subtree: true, characterData: true });
    } catch (e) {}
    document.addEventListener('cart:updated', function () {
      setTimeout(function () {
        scan(document);
      }, 50);
    });
    // Segunda pasada por si Shopify pinta precios tarde
    setTimeout(function () {
      scan(document);
    }, 400);
    setTimeout(function () {
      scan(document);
    }, 1200);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
